import { render, staticRenderFns } from "./01NumberOfPlayers.vue?vue&type=template&id=06706d35&"
import script from "./01NumberOfPlayers.vue?vue&type=script&lang=js&"
export * from "./01NumberOfPlayers.vue?vue&type=script&lang=js&"
import style0 from "./01NumberOfPlayers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports